import { graphql, useStaticQuery } from "gatsby"
import type { SquidexMarkdownEmbeddedContent } from "~/types/squidex"

type Query = {
  GraphCmsSquidex: {
    findCheckoutConfigurationSingleton: {
      flatData: {
        hasStepsInHeader: boolean | null
        expandedTerms: { id: number }[]
        termsText: SquidexMarkdownEmbeddedContent
        tabsTermId?: number
      }
    }
  }
}

export function useCheckoutConfigurationQuery(): Query["GraphCmsSquidex"]["findCheckoutConfigurationSingleton"]["flatData"] {
  const {
    GraphCmsSquidex: { findCheckoutConfigurationSingleton },
  } = useStaticQuery<Query>(graphql`
    {
      GraphCmsSquidex {
        findCheckoutConfigurationSingleton {
          flatData {
            hasStepsInHeader
            termsText {
              text
              contents {
                ... on GraphCmsSquidex_StaticPrice {
                  ...StaticPrice
                }
                ... on GraphCmsSquidex_MarketplaceSaleConfiguration {
                  ...SaleConfigurations
                }
                ... on GraphCmsSquidex_CloudblueDomain {
                  ...CloudBlueDomain
                }
                ... on GraphCmsSquidex_PriceTypeContextText {
                  ...PriceTypeContextText
                }
                ... on GraphCmsSquidex_Tooltip {
                  ...Tooltip
                }
              }
            }
            expandedTerms {
              id
            }
            tabsTermId
          }
        }
      }
    }
  `)

  return findCheckoutConfigurationSingleton.flatData
}
